<!-- 特惠活动 -->
<template>
  <div class="">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="2"></HeaderNav>
    <div class="img_box">
      <div class="title">
        {{ title }}
        <div class="sub">{{ sub }}</div>
      </div>
      <div>{{cont}}</div>
      <div class="pc_img"><img alt="" :src="item" style="max-width: 100%;height: auto;" v-for="(item, index) in pcImg" :key="index" /></div>
      <div class="wap_img"><img alt="" :src="wapImg" style="max-width: 100%;height: auto;" v-for="(item, index) in wapImg" :key="index" /></div>
    </div>
    <hr class="hr_1 mt0 mb30" />
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import RightNav from '../../components/RightNav.vue';
import { apiGetAdvert, apiGetList } from '../../api/activity.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    RightNav: RightNav
  },
  data() {
    return {
      title: '',
      sub: '',
      cont:'',
      pcImg: [],
      wapImg: []
    };
  },
  created() {
    if (this.$route.query.id == 1) {
        this.title = 'Super us，Beyond us',
        this.sub = '品牌年度盛典',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/1/1.jpg',
          'static/picture/NEW/1/2.jpg',
          'static/picture/NEW/1/3.jpg',
          'static/picture/NEW/1/4.jpg',
          'static/picture/NEW/1/5.jpg',
          'static/picture/NEW/1/6.jpg',
          'static/picture/NEW/1/7.jpg',
          'static/picture/NEW/1/8.jpg'
        ];
      this.wapImg = [
        'static/picture/NEW/1/1.jpg',
        'static/picture/NEW/1/2.jpg',
        'static/picture/NEW/1/3.jpg',
        'static/picture/NEW/1/4.jpg',
        'static/picture/NEW/1/5.jpg',
        'static/picture/NEW/1/6.jpg',
        'static/picture/NEW/1/7.jpg',
        'static/picture/NEW/1/8.jpg'
      ];
    }
    if (this.$route.query.id == 2) {
        this.title = '进博会LEWA魅力出圈',
        this.sub = '进博会首秀回顾',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/2/1.jpg',
          'static/picture/NEW/2/2.jpg',
          'static/picture/NEW/2/3.jpg',
          'static/picture/NEW/2/4.jpg',
          'static/picture/NEW/2/5.jpg',
          'static/picture/NEW/2/6.jpg',
          'static/picture/NEW/2/7.jpg',
          'static/picture/NEW/2/8.jpg',
          'static/picture/NEW/2/9.jpg'
        ];
      this.wapImg = [
        'static/picture/NEW/2/1.jpg',
        'static/picture/NEW/2/2.jpg',
        'static/picture/NEW/2/3.jpg',
        'static/picture/NEW/2/4.jpg',
        'static/picture/NEW/2/5.jpg',
        'static/picture/NEW/2/6.jpg',
        'static/picture/NEW/2/7.jpg',
        'static/picture/NEW/2/8.jpg',
        'static/picture/NEW/2/9.jpg'
      ];
    }
    if (this.$route.query.id == 3) {
        this.title = '美肤新势力“耀”你好看',
        this.sub = '我们上海见！',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/3/1.jpg',
          'static/picture/NEW/3/2.jpg',
          'static/picture/NEW/3/3.jpg',
          'static/picture/NEW/3/4.jpg',
          'static/picture/NEW/3/5.jpg',
          'static/picture/NEW/3/6.jpg',
          'static/picture/NEW/3/7.jpg',
          'static/picture/NEW/3/8.jpg'
        ];
      this.wapImg = [
        'static/picture/NEW/3/1.jpg',
        'static/picture/NEW/3/2.jpg',
        'static/picture/NEW/3/3.jpg',
        'static/picture/NEW/3/4.jpg',
        'static/picture/NEW/3/5.jpg',
        'static/picture/NEW/3/6.jpg',
        'static/picture/NEW/3/7.jpg',
        'static/picture/NEW/3/8.jpg'
      ];
    }
    if (this.$route.query.id == 4) {
        this.title = 'LEWA株式会社将亮相进博会',
        this.sub = '进博会，我们来啦',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/4/1.png',
          'static/picture/NEW/4/2.png',
          'static/picture/NEW/4/3.png',
          'static/picture/NEW/4/4.png',
          'static/picture/NEW/4/5.png',
          'static/picture/NEW/4/6.png',
          'static/picture/NEW/4/7.png'
        ];
      this.wapImg = [
       'static/picture/NEW/4/1.png',
       'static/picture/NEW/4/2.png',
       'static/picture/NEW/4/3.png',
       'static/picture/NEW/4/4.png',
       'static/picture/NEW/4/5.png',
       'static/picture/NEW/4/6.png',
       'static/picture/NEW/4/7.png'
      ];
    }
    if (this.$route.query.id == 5) {
        this.title = 'Luara实力出圈，引领美肌风尚',
        this.sub = '',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/5/1.jpg',
          'static/picture/NEW/5/2.gif',
          'static/picture/NEW/5/3.gif',
          'static/picture/NEW/5/4.jpg',
          'static/picture/NEW/5/5.gif',
          'static/picture/NEW/5/6.jpg',
          'static/picture/NEW/5/7.gif',
          'static/picture/NEW/5/8.jpg',
        ];
      this.wapImg = [
        'static/picture/NEW/5/1.jpg',
        'static/picture/NEW/5/2.gif',
        'static/picture/NEW/5/3.gif',
        'static/picture/NEW/5/4.jpg',
        'static/picture/NEW/5/5.gif',
        'static/picture/NEW/5/6.jpg',
        'static/picture/NEW/5/7.gif',
        'static/picture/NEW/5/8.jpg',
      ];
    }
    if (this.$route.query.id == 6) {
        this.title = '当Luara撞上时尚之都',
        this.sub = 'Luara成都专柜开业',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/6/1.jpg',
          'static/picture/NEW/6/2.jpg',
          'static/picture/NEW/6/3.jpg',
          'static/picture/NEW/6/4.jpg',
          'static/picture/NEW/6/5.jpg',
          'static/picture/NEW/6/6.jpg',
          'static/picture/NEW/6/7.jpg',
          'static/picture/NEW/6/8.jpg',
          'static/picture/NEW/6/9.jpg',
          'static/picture/NEW/6/10.jpg',
          'static/picture/NEW/6/11.jpg',
        ];
      this.wapImg = [
        'static/picture/NEW/6/1.jpg',
        'static/picture/NEW/6/2.jpg',
        'static/picture/NEW/6/3.jpg',
        'static/picture/NEW/6/4.jpg',
        'static/picture/NEW/6/5.jpg',
        'static/picture/NEW/6/6.jpg',
        'static/picture/NEW/6/7.jpg',
        'static/picture/NEW/6/8.jpg',
        'static/picture/NEW/6/9.jpg',
        'static/picture/NEW/6/10.jpg',
        'static/picture/NEW/6/11.jpg',
      ];
    }
    if (this.$route.query.id == 7) {
        this.title = '定义美 绽放美',
        this.sub = '以美为媒 携手同行',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/7/1.jpg',
          'static/picture/NEW/7/2.jpg',
          'static/picture/NEW/7/3.jpg',
          'static/picture/NEW/7/4.jpg',
          'static/picture/NEW/7/5.jpg',
        ];
      this.wapImg = [
        'static/picture/NEW/7/1.jpg',
        'static/picture/NEW/7/2.jpg',
        'static/picture/NEW/7/3.jpg',
        'static/picture/NEW/7/4.jpg',
        'static/picture/NEW/7/5.jpg',
      ];
    }
    if (this.$route.query.id == 8) {
        this.title = '新品来袭 Luara眼霜',
        this.sub = '开启明眸焕采之旅',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/8/1.gif',
          'static/picture/NEW/8/2.jpg',
          'static/picture/NEW/8/3.jpg',
          'static/picture/NEW/8/4.jpg',
          'static/picture/NEW/8/5.jpg',
        ];
      this.wapImg = [
        'static/picture/NEW/8/1.gif',
        'static/picture/NEW/8/2.jpg',
        'static/picture/NEW/8/3.jpg',
        'static/picture/NEW/8/4.jpg',
        'static/picture/NEW/8/5.jpg',
      ];
    }
    if (this.$route.query.id == 9) {
        this.title = 'Luara武汉专柜',
        this.sub = '',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/9/1.png',
          'static/picture/NEW/9/2.png',
          'static/picture/NEW/9/3.png',
          'static/picture/NEW/9/4.png',
        ];
      this.wapImg = [
          'static/picture/NEW/9/1.png',
          'static/picture/NEW/9/2.png',
          'static/picture/NEW/9/3.png',
          'static/picture/NEW/9/4.png',
      ];
    }
    if (this.$route.query.id == 10) {
        this.title = '与美同行 绽放光芒',
        this.sub = '以美的名义，邀你同行！',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/10/1.png',
          'static/picture/NEW/10/2.png',
          'static/picture/NEW/10/3.png',
          'static/picture/NEW/10/4.png',
        ];
      this.wapImg = [
        'static/picture/NEW/10/1.png',
        'static/picture/NEW/10/2.png',
        'static/picture/NEW/10/3.png',
        'static/picture/NEW/10/4.png',
      ];
    }
    if (this.$route.query.id == 11) {
        this.title = '点击解锁三亚游学指南',
        this.sub = '探寻真实的自我',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/11/1.jpg',
          'static/picture/NEW/11/2.jpg',
        ];
      this.wapImg = [
        'static/picture/NEW/11/1.jpg',
        'static/picture/NEW/11/2.jpg',
      ];
    }
    if (this.$route.query.id == 12) {
        this.title = '约定广州CIBE，Luara光芒将再度闪耀！',
        this.sub = '再次释放美丽',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/12/1.gif',
          'static/picture/NEW/12/2.gif',
          'static/picture/NEW/12/3.png',
        ];
      this.wapImg = [
          'static/picture/NEW/12/1.gif',
          'static/picture/NEW/12/2.gif',
          'static/picture/NEW/12/3.png',
      ];
    }
    if (this.$route.query.id == 13) {
        this.title = 'Luara即将进驻上海美博会',
        this.sub = '现场解码美',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/13/1.jpg',
          'static/picture/NEW/13/2.jpg',
          'static/picture/NEW/13/3.jpg',
          'static/picture/NEW/13/4.jpg',
          'static/picture/NEW/13/5.jpg',
        ];
      this.wapImg = [
          'static/picture/NEW/13/1.jpg',
          'static/picture/NEW/13/2.jpg',
          'static/picture/NEW/13/3.jpg',
          'static/picture/NEW/13/4.jpg',
          'static/picture/NEW/13/5.jpg',
      ];
    }
    if (this.$route.query.id == 14) {
        this.title = 'Luara上海专柜',
        this.sub = '邀你解锁发光肌，感受肌肤的',
        this.cont = '',
        this.pcImg = [
          'static/picture/NEW/14/1.jpg',
          'static/picture/NEW/14/2.jpg',
          'static/picture/NEW/14/3.jpg',
          'static/picture/NEW/14/4.jpg',
          'static/picture/NEW/14/5.jpg',
        ];
      this.wapImg = [
          'static/picture/NEW/14/1.jpg',
          'static/picture/NEW/14/2.jpg',
          'static/picture/NEW/14/3.jpg',
          'static/picture/NEW/14/4.jpg',
          'static/picture/NEW/14/5.jpg',
      ];
    }
    if (this.$route.query.id == 15) {
        this.title = 'Luara快闪店第3站惊艳来袭',
        this.sub = 'Luara与您的美丽之约，如期而至',
        this.cont = '',
        this.pcImg = [];
        this.wapImg = [];
    }
    if (this.$route.query.id == 16) {
        this.title = 'Luara肌底液焕新来袭',
        this.sub = 'Luara肌底液迭代升级，全新包装',
        this.cont = '肌底液，作为Luara全系列中的明星产品，凭借着院线产品专业的肌肤护理功效和优良的品质，备受日本美容教母佐伯千津老师、日本"不老仙妻"水谷雅子等名人的推崇，在中国也拥有许多“铁粉"。',
        this.pcImg = [];
        this.wapImg = [];
    }
    if (this.$route.query.id == 17) {
        this.title = '听说长得好看的人，洗脸都用棉柔巾！',
        this.sub = '生活故事棉柔巾，全新上市！',
        this.cont = '生活故事绵柔巾，贴心盒装、袋装任选，盒装，摆在家中美观大方；袋装，出门携带方便；抽取式设计，用一张抽一张，不会滋生螨虫和细菌，不会对皮肤造成二次污染。',
        this.pcImg = [];
      this.wapImg = [];
    }







  },
  methods: {}
};
</script>
<style scoped>
.title {
  margin: 40px auto;
  text-align: center;
  font-size: 40px;
  line-height: 40px;
  color: #2e2e2e;
  font-family: Font_Normal;
}
.sub {
  text-align: center;
  margin: 20px auto 40px;
  text-align: center;
  font-size: 24px;
  color: #2e2e2e;
}
.img_box {
  max-width: 840px;
  padding: 40px 0 60px;
}
/* @media screen and (min-width: 0px) and (max-width: 768px) { */
@media screen and (max-width: 768px) {
  .title {
    margin: 30px auto;
    text-align: center;
    font-size: 30px;
    line-height: 40px;
    color: #2e2e2e;
    font-family: Font_Normal;
  }
  .sub {
    text-align: center;
    margin: 20px auto 40px;
    text-align: center;
    font-size: 24px;
    color: #2e2e2e;
  }
  .img_box {
    max-width: 840px;
    padding: 40px 0 60px;
  }
}

@media (min-width: 768px) {
  .nav li {
    padding: 0 15px;
  }
  .pc_img {
    display: none;
  }
  .wap_img {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: block;
  }
  .pc_img {
    display: block;
  }
  .wap_img {
    display: none;
  }
  .img_box .video_box .zhezhao img.img_pc {
    display: block;
  }
  .img_box .video_box .zhezhao img.img_wap {
    display: none;
  }
}
/*------------brand.html  start----------------*/
.img_box {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
}
.img_box img {
  max-width: 100%;
  margin: 0 auto;
  display: block;
}
.img_box .video_box {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.img_box .video_box .zhezhao {
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0px;
  top: 0px;
  z-index: 555;
  overflow: hidden;
  cursor: pointer;
}
.img_box .video_box .zhezhao img {
  width: 100%;
  height: 100%;
  transition: all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc {
  display: block;
}
.img_box .video_box .zhezhao img.img_wap {
  display: none;
}
.img_box .video_box video {
  width: 100%;
}
/*------------brand.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/News/Detail.vue